// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/dc376e078b8769b84598.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"89a08acdd25046c02bdd","265":"1e967a8d9130fd3e219a","266":"b496f2dcb45f4392e63a"}[chunkId] + ".chunk.js";
};